import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup} from '@angular/forms';
import { UserRequestService } from '../../data-access/requests.service';

@Component({
    selector: 'app-cancelrequest',
    templateUrl: './cancelrequest.component.html',
    styleUrls: ['./cancelrequest.component.scss'],
    standalone: false
})
export class CancelRequestComponent {
  @Input() prfyear: number;
  @Input() groupcode: string;
  @Input() ticketid: string;
  @Input() prfuser: string;

  requestForm: FormGroup;
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private requestService: UserRequestService
  ) { }

  cancelRequest(prfyear: number, groupcode: string, requestticketid: string, actiontype: string, prfuser: string): void {
    this.isLoading = true;
    this.errorMessage = null;

    const payload = {
      prfyear,
      groupcode,
      prfuser,
      requestticketid,
      actiontype
    };

    this.requestService.cancelUserRequest(payload).subscribe({
      next: (response: { status: string; message?: string }) => {
        if (response.message !== 'Success') {
          this.errorMessage = response.message || 'Error canceling request. Please try again.';
          this.isLoading = false;
        } else {
          this.activeModal.close(true);
        }
      },
      error: (error) => {
        this.errorMessage = 'Error canceling request. Please try again.';
        this.isLoading = false;
      },
    });
  }
}
